import {
    Autocomplete, Box, IconButton, Table, TableBody, TableCell, TableHead,
    TableRow, TextField, Typography, Tooltip, Dialog, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import '../UmaDocNotes.css';
import { COMMON_STYLE, SPH_OPTIONS, CYL_OPTIONS, AXIS_OPTIONS, BCDVA_OPTIONS } from '../../../../Utility/Constants';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const commonArr = [
    { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "", "BCDVA": "" },
    { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "", "BCDVA": "" },
]

const headers = ['Eye', 'SPH', 'CYL', 'AXIS', 'BCDVA'];

const deepCopyFunc = (arr) => {
    return JSON.parse(JSON.stringify(arr))
}

const UmaSmile = React.forwardRef((props, ref) => {
    const [smile, setSmile] = useState({
    SPHList: SPH_OPTIONS,
    CYLList: CYL_OPTIONS,
    AXISList: AXIS_OPTIONS,
    BCDVAList: BCDVA_OPTIONS,
    smileComments: '',
    prevSmileComments: '',
    underRefractionData: deepCopyFunc(commonArr),
    prevUnderRefractionData: [],
    acceptanceData: deepCopyFunc(commonArr),
    prevAcceptanceData: [],
    overRefractionData: deepCopyFunc(commonArr),
    prevOverRefractionData: [],
    openCompareUnderPopup: false,
    openCompareAccepPopup: false,
    openCompareOverPopup: false,
    loadScreen: false,
    enableCompareUnder: false,
    enableCompareAccep: false,
    enableCompareOver: false,
    enableCopyUnder: false,
    enableCopyAccep: false,
    enableCopyOver: false,
    dupSmileComments: '',
    dupUnderRefractionData: [],
    dupAcceptanceData: [],
    dupOverRefractionData: [],
    id: null,
    accordionOpen: false,
})
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: `${message} - SMILE`,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: `${message} - SMILE`,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    React.useImperativeHandle(ref, () => ({
        performSmileAction: () => {
            if (
                (JSON.stringify(smile.smileComments) !== smile.dupSmileComments) ||
                (JSON.stringify(smile.underRefractionData) !== smile.dupUnderRefractionData) ||
                (JSON.stringify(smile.acceptanceData) !== smile.dupAcceptanceData) ||
                (JSON.stringify(smile.overRefractionData) !== smile.dupOverRefractionData)
            ) {
                postSmileData()
            }
        },
        setAccordionOpen: (isOpen) => {
            setSmile((prev) => ({ ...prev, accordionOpen: isOpen }));
        }
    }))

    const apicalls = async () => {
        await getSmileData()
        await getPrevSmileData()
    }


    const hasNonEmptyFields = (data) =>
        Array.isArray(data) && data.some(item => item?.SPH || item?.CYL || item?.AXIS || item?.BCDVA);

    useEffect(() => {

        if (smile.underRefractionData && smile.acceptanceData && smile.prevAcceptanceData && smile.prevUnderRefractionData && smile.overRefractionData && smile.prevOverRefractionData) {
            setSmile((prev) => ({
                ...prev,
                enableCompareUnder: hasNonEmptyFields(smile.underRefractionData),
                enableCompareAccep: hasNonEmptyFields(smile.acceptanceData),
                enableCompareOver: hasNonEmptyFields(smile.overRefractionData),
                enableCopyUnder: hasNonEmptyFields(smile.prevUnderRefractionData),
                enableCopyAccep: hasNonEmptyFields(smile.prevAcceptanceData),
                enableCopyOver: hasNonEmptyFields(smile.prevOverRefractionData),
            }))
        }
    }, [smile.underRefractionData, smile.acceptanceData, smile.prevAcceptanceData, smile.prevUnderRefractionData, smile.overRefractionData, smile.prevOverRefractionData])

    const getSmileData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_SMILE + '?appointment_id=' + props.props.appointment_id + '&doctor_id=' + props?.props?.doctorID)
            if (response?.data?.status === 'success') {
                const Data = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                const isDataAvailable = (Data?.comment && Data?.comments?.trim()) || hasNonEmptyFields(Data?.under_refraction) || hasNonEmptyFields(Data?.acceptances) || hasNonEmptyFields(Data?.over_refraction);
                setSmile((prev) => ({
                    ...prev,
                    id: Data?.id,
                    smileComments: Data?.comment ? Data?.comment : '',
                    underRefractionData: Data?.under_refraction?.length > 0 ? Data?.under_refraction : deepCopyFunc(commonArr),
                    acceptanceData: Data?.acceptances?.length > 0 ? Data?.acceptances : deepCopyFunc(commonArr),
                    overRefractionData: Data?.over_refraction?.length > 0 ? Data?.over_refraction : deepCopyFunc(commonArr),
                    dupSmileComments: Data?.comment ? JSON.stringify(Data?.comment) : '',
                    dupUnderRefractionData: Data?.under_refraction?.length > 0 ? JSON.stringify(Data?.under_refraction) : JSON.stringify(commonArr),
                    dupAcceptanceData: Data?.acceptances?.length > 0 ? JSON.stringify(Data?.acceptances) : JSON.stringify(commonArr),
                    dupOverRefractionData: Data?.over_refraction > 0 ? JSON.stringify(Data?.over_refraction) : JSON.stringify(commonArr),
                    accordionOpen: isDataAvailable,
                }))
                props.syncAccordionOpen?.(isDataAvailable);
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error?.message)
        }
    }

    const getPrevSmileData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PREV_SMILE +
                '?appointment_id=' + props.props.appointment_id + '&patient_id=' + props.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
            )
            if (response?.data?.status === 'success') {
                const Data = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                setSmile((prev) => ({
                    ...prev,
                    prevSmileComments: Data?.comment ? Data?.comment : '',
                    prevUnderRefractionData: Data?.under_refraction?.length > 0 ? Data?.under_refraction : [],
                    prevAcceptanceData: Data?.acceptances?.length > 0 ? Data?.acceptances : [],
                    prevOverRefractionData: Data?.over_refraction?.length > 0 ? Data?.over_refraction : [],
                }))
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error?.message)
        }
    }

    const postSmileData = async () => {
        try {
            const data = {
                "id": smile.id,
                "appointment_id": props.props?.appointment_id,
                "comment": smile.smileComments || "",
                "under": smile.underRefractionData,
                "accept": smile.acceptanceData,
                "over": smile.overRefractionData,
            }
            const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_SMILE)
            if (response?.data?.status === 'success') {
                successMessage(response?.data?.message)
                await getSmileData()
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error?.message)
        }
    }

    const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index, arr) => {
        try {
            return (
                <Autocomplete
                    disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                    clearIcon
                    size='small'
                    sx={{ width: '7dvw' }}
                    value={values || ""}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
                    onChange={(e, newValue) => {
                        let updateArr = [...smile[arr]]
                        updateArr[index] = { ...updateArr[index], [names]: newValue ? newValue?.label || "" : "" }
                        setSmile((prev) => ({ ...prev, [arr]: updateArr }))
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const commonTblCopyCompare = (label, enableCopy, enableCompare, openComparePopup, arrKey, prevArrKey) => {
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>{label}</Typography>
                        <Box component={'div'} display={'flex'} alignItems={'center'} ml={'0.5rem'}>
                            <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_cpy'
                                disabled={!smile[enableCopy] || props?.props?.patient_transfered || props?.props?.isLocked}
                                onClick={() => setSmile((prev) => ({
                                    ...prev, [openComparePopup]: false,
                                    [arrKey]: prev[prevArrKey]
                                }))}
                            ><ContentCopyIcon color={!smile[enableCopy] ? '' : 'primary'} /></IconButton></Tooltip>
                            <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_vis'
                                onClick={() => setSmile((prev) => ({ ...prev, [openComparePopup]: true }))}
                                disabled={!(smile[enableCopy] && smile[enableCompare]) || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><VisibilityIcon color={!(smile[enableCopy] && smile[enableCompare]) ? '' : 'primary'} /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    {headers.map((text, idx) => (
                                        <TableCell className='doc_notes_tbl_header' key={idx}>{text}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {smile?.[arrKey]?.length > 0 ? smile[arrKey].map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, smile?.SPHList, 'label', 'SPH', index, arrKey)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, smile?.CYLList, 'label', 'CYL', index, arrKey)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, smile?.AXISList, 'label', 'AXIS', index, arrKey)}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('BCDVA', item?.BCDVA, smile?.BCDVAList, 'label', 'BCDVA', index, arrKey)}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={5}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderTable = (arrKey) => {
        return (
            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                    <TableHead>
                        {headers.map((text, idx) => (
                            <TableCell className='doc_notes_tbl_header' key={idx}>{text}</TableCell>
                        ))}
                    </TableHead>
                    <TableBody>
                        {smile[arrKey]?.map((item, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                    <TableCell className='doc_notes_tbl_body_cell'>{item.BCDVA}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </Box>
        )
    }

    const renderComparePopup = (label, openKey, arrKey, prevArrKey) => {
        try {
            return (
                <Dialog open={smile[openKey]} maxWidth="md" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>{`Compare ${label}`} </Typography>
                            <IconButton emed_tid='cmp_prev_cls'
                                onClick={() => setSmile((prev) => ({ ...prev, [openKey]: false }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>{`Current ${label}`}</Typography>
                                <Tooltip placement='top' arrow title={'Copy'}>
                                    <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                                        onClick={() => {
                                            setSmile((prev) => ({
                                                ...prev,
                                                [arrKey]: prev[prevArrKey],
                                                [openKey]: false
                                            }))
                                        }}
                                    ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
                            </Box>
                            {renderTable(prevArrKey)}
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography className='doc_notes_header_card_font'>{`New ${label}`}</Typography>
                            {renderTable(arrKey)}
                        </Box>
                    </Box>
                </Dialog >
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <ShowComponents onIntersection={apicalls}>
            <Box component={'div'}>
                <Accordion expanded={smile.accordionOpen}
                    onChange={(_, isExpanded) => {
                        setSmile((prevState) => ({ ...prevState, accordionOpen: isExpanded }));
                        props.syncAccordionOpen?.(isExpanded);
                    }}>
                    <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
                        <Typography className='doc_notes_header_card_font'>Smile</Typography>
                    </AccordionSummary>
                    <AccordionDetails component={'div'} m={'0.5rem'}>
                        {commonTblCopyCompare("Under Refraction", "enableCopyUnder", "enableCompareUnder", "openCompareUnderPopup", "underRefractionData", "prevUnderRefractionData")}
                        {commonTblCopyCompare("Acceptances", "enableCopyAccep", "enableCompareAccep", "openCompareAccepPopup", "acceptanceData", "prevAcceptanceData")}
                        {commonTblCopyCompare("Over Refraction", "enableCopyOver", "enableCompareOver", "openCompareOverPopup", "overRefractionData", "prevOverRefractionData")}

                        <Box component={'div'}>
                            <TextField
                                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                                size='small'
                                multiline
                                fullWidth
                                maxRows={5}
                                value={smile.smileComments}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                                        setSmile((prev) => ({ ...prev, smileComments: value }))
                                    }
                                }}
                                placeholder='Comments'
                                inputProps={{ maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>
                {renderComparePopup("Under Refraction", "openCompareUnderPopup", "underRefractionData", "prevUnderRefractionData")}
                {renderComparePopup("Acceptances", "openCompareAccepPopup", "acceptanceData", "prevAcceptanceData")}
                {renderComparePopup("Over Refraction", "openCompareOverPopup", "overRefractionData", "prevOverRefractionData")}
                {message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
                {message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            </Box>
        </ShowComponents>
    )
})

export default UmaSmile